import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  translationConstants,
  paymentConstants,
  roles,
} from "../../../constants";
import { getUserPayload, moveBack } from "../../../system";
import ConfirmationModal from "../Modals/ConfirmationModal";
import CustomModal from "../CustomModal/CustomModal";
import minus from "../../../assets/images/icon/minus_icon.svg";
import tick from "../../../assets/images/icon/tick.svg";
import { paymentActions } from "../../../redux/actions";
import { Form } from "react-bootstrap";

const SaveCard = (props) => {
  const { savedCard, isUpdate, setSelectedCardId, selectCardId } = props;
  const userPayload = getUserPayload();
  const { t } = useTranslation();
  const [showConfirmationModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (savedCard.isDefault) {
      setSelectedCardId(savedCard.id);
    }
  }, [savedCard]);

  const profileData = useSelector((state) => state.ProfileReducer.profileData);
  return (
    <>
      <div className="row w-100 mt-12">
        <div className="col-md-8">
          <p className="card-div-display">
            <svg
              width="17"
              height="12"
              viewBox="0 0 17 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.68958 7.6678V9.09072H5.1125V7.6678H3.68958Z"
                fill="black"
              />
              <path
                d="M5.82396 9.09072V7.6678H7.95833V9.09072H5.82396Z"
                fill="black"
              />
              <path
                d="M12.2271 7.6678V9.09072H13.65V7.6678H12.2271Z"
                fill="black"
              />
              <path
                d="M10.0927 9.09072V7.6678H11.5156V9.09072H10.0927Z"
                fill="black"
              />
              <path
                d="M5.82396 4.11051H3.68958V6.24489H5.82396V4.11051Z"
                fill="black"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.13731 0.553223H15.2023C15.9167 0.553223 16.4958 1.19028 16.4958 1.97614V10.5136C16.4958 11.2995 15.9167 11.9366 15.2023 11.9366H2.13731C1.4229 11.9366 0.84375 11.2995 0.84375 10.5136V1.97614C0.84375 1.19028 1.4229 0.553223 2.13731 0.553223ZM2.26667 1.97614V10.5136H15.0729V1.97614H2.26667Z"
                fill="black"
              />
            </svg>
            <span className="p-l-10 card-num">
              {t(translationConstants.CARD_NUMBER)}:
            </span>
          </p>
          <span className="mt-12">
            {paymentConstants.CARD_NUMBER_MASK} {savedCard?.last4Digits}
          </span>
        </div>
        <div className="col-md-4 d-flex">
          <div className="col-8">
            <p className="card-num">{t(translationConstants.CARD_EXPIRY)}:</p>
            <span className="mt-12">
              {savedCard?.expiryMonth + "/" + savedCard?.expiryYear}
            </span>
          </div>
          <div className="col-4 d-flex justify-content-end">
            {!isUpdate ? (
              savedCard.isDefault ? (
                <img
                  className="height-width-25"
                  src={tick}
                  alt="secure lock icon"
                />
              ) : (
                <img
                  src={minus}
                  alt="secure lock icon"
                  className="height-width-25 cursor-pointer"
                  onClick={() => setShowModal(true)}
                />
              )
            ) : (
              <Form.Check
                type="radio"
                id="inline-radio-1"
                checked={selectCardId === savedCard.id}
                defaultChecked={selectCardId === savedCard.id}
                onChange={() => {
                  setSelectedCardId(savedCard.id);
                }}
              />
            )}
          </div>
        </div>
      </div>

      <CustomModal
        scrollable={true}
        size="md"
        setShow={setShowModal}
        show={showConfirmationModal}
        customClass="view-user-modal"
      >
        <ConfirmationModal
          title={t(translationConstants.CONFIRMATION)}
          messageLine1={t(translationConstants.ARE_YOU_SURE_TO_REMOVE)}
          messageLine2={""}
          onCancel={() => setShowModal(!showConfirmationModal)}
          onSubmit={() => {
            let onSuccessOBJ;
            if (userPayload?.user?.role === roles.Center) {
              onSuccessOBJ = {
                centerId: profileData?.userInfo?.id
                  ? profileData?.userInfo?.id
                  : props.centerId,
              };
            } else {
              onSuccessOBJ = {
                systemUserId: userPayload?.user?.id,
              };
            }

            dispatch(
              paymentActions.deleteCardById(savedCard?.id, onSuccessOBJ)
            );
            setShowModal(!showConfirmationModal);
          }}
        />
      </CustomModal>
    </>
  );
};

export default SaveCard;
